import Request from './request';
import axios from 'axios';
import request_configs from './request_configs';

// 获取B2b AccessToken
async function getB2bAccessToken(data) {
    return Request('post', "api/wechat-b2b/getB2bAccessToken", data);
}

// 修改服务器域名
async function modifyServerDomain(data) {
    return Request('post', "api/wechat-b2b/modifyServerDomain", data);
}

// 获取模板列表
async function getTemplateList(data) {
    return Request('get', "api/wechat-b2b/getTemplateList", data);
}

// 上传代码并生成体验版
async function commit(data) {
    return Request('post', "api/wechat-b2b/commit", data);
}

// 获取体验版二维码
async function getTrialQRCode(data) {
    return Request('post', "api/wechat-b2b/getTrialQRCode", data);
}

// 获取已上传的代码页面列表
async function getUploadedPage(data) {
    return Request('post', "api/wechat-b2b/getUploadedPage", data);
}

// 获取已认证的类目
async function getCategory(data) {
    return Request('post', "api/wechat-b2b/getCategory", data);
}

// 提交代码审核
async function submitAudit(data) {
    return Request('post', "api/wechat-b2b/submitAudit", data);
}

// 查询审核单状态
async function getAuditStatus(data) {
    return Request('post', "api/wechat-b2b/getAuditStatus", data);
}

// 查询最新一次审核单状态
async function getLatestAuditStatus(data) {
    return Request('post', "api/wechat-b2b/getLatestAuditStatus", data);
}

// 获取或配置小程序域名
async function modifyDomain(data) {
    return Request('post', "api/wechat-b2b/modifyDomain", data);
}

// 获取隐私接口检测结果
async function getCodePrivacyInfo(data) {
    return Request('post', "api/wechat-b2b/getCodePrivacyInfo", data);
}

// 获取小程序隐私协议
async function getPrivacySetting(data) {
    return Request('post', "api/wechat-b2b/getPrivacySetting", data);
}

// 设置小程序隐私协议
async function setPrivacySetting(data) {
    return Request('post', "api/wechat-b2b/setPrivacySetting", data);
}

// 发布小程序
async function release(data) {
    return Request('post', "api/wechat-b2b/release", data);
}

// 获取体验版二维码（返回 blob 图片）
async function getTrialQRCodeImage(data) {
  request_configs.Headers['access-token'] = localStorage.getItem('accessToken');
  return axios.post('api/wechat-b2b/getTrialQRCode', data, {
    responseType: 'blob',
    headers: request_configs.Headers,
  });
}

// 申请费率
async function setmchprofitrate(data) {
    return Request('post', "api/wechat-b2b/setmchprofitrate", data);
}

export default {
    getB2bAccessToken,
    modifyServerDomain,
    getTemplateList,
    commit,
    getTrialQRCode,
    getTrialQRCodeImage,
    getUploadedPage,
    getCategory,
    submitAudit,
    getAuditStatus,
    getLatestAuditStatus,
    modifyDomain,
    getCodePrivacyInfo,
    getPrivacySetting,
    setPrivacySetting,
    release,
    setmchprofitrate,
};
